import { useQuery } from '@tanstack/react-query'

import { get } from 'utils/http'

export const useCustomerAIContext = (customerId: any) => {
  const getAIContext = async () => {
    try {
      return await get(`/management/customers/${customerId}/ai_context`)
    } catch (e: any) {
      if (e.status === 404) return null
      throw e
    }
  }
  return useQuery({
    queryKey: ['customer', 'ai', customerId],
    queryFn: getAIContext,
    // Don't fire `/customers/undefined/ai_context` before the customer id is known.
    enabled: !!customerId,
  })
}
